import React from 'react';
import { Link } from 'react-router-dom';
import SEO from '../components/SEO';
import { PageContainer, PageTitle } from '../components/PageHeader';
import '../styles/help.css';

// Renders inside the app shell (Layout's sidebar + topbar) like any other
// in-app route — no standalone header/back button/full-viewport wrapper.
// /privacy and /terms stay standalone (see Layout.jsx isLegalPage); /help
// does not, since it's the sidebar's own Help destination.
const HelpPage = () => {
    return (
        <>
            <SEO
                title="Help & Support"
                description="Need help with Graspd? Contact our support team for assistance with our AI-powered learning platform."
                path="/help"
            />

            <PageContainer
                style={{
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    padding: 'clamp(32px, 6vw, 64px) var(--space-4)',
                }}
            >
                <div className="help-container">
                    <div className="help-content">
                        <PageTitle>Need help?</PageTitle>
                        <p className="help-subtext">
                            We're here to help. Reach out and we'll get back to you as soon as possible.
                        </p>

                        <a
                            href="mailto:contact@graspd.ai"
                            className="help-email-link"
                        >
                            contact@graspd.ai
                        </a>

                        <div className="help-legal-links">
                            <Link to="/terms">Terms of Service</Link>
                            <span className="help-divider">·</span>
                            <Link to="/privacy">Privacy Policy</Link>
                        </div>
                    </div>
                </div>
            </PageContainer>
        </>
    );
};

export default HelpPage;
